export default "__VITE_ASSET__S$E5O_Pm__"